import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { Subscription } from 'rxjs';
import { LottosService } from '../../services/lottos/lottos.service';
import { environment } from '../../../environments/environment';
import { WindorefService } from '../../services/window/windoref.service';

@Component({
  selector: 'app-logo-lotto',
  templateUrl: './logo-lotto.component' + AuthService.multisite.view + '.html',
  styleUrls: ['./logo-lotto.component.scss']
})
export class LogoLottoComponent implements OnInit {
  @Input() size: number = 95;
  @Input() flat: boolean = false;
  public lottoId = environment.lottery.lot_id;
  public lottoName: string;
  public product: string;
  public prodId: number;
  public sys: string;
  public baseUrl: string = 'https://d3tmfelegj51yl.cloudfront.net/lotto-logos/';
  public subs: Subscription;

  constructor(protected lottos: LottosService, private _winRef: WindorefService) {}

  ngOnInit(): void {
    this.setLottoName();
  }

  setLottoName(): void {
    this.subs = this.lottos.lottoObservable$.subscribe((lottoObj) => {
      this.lottoName = lottoObj['name'];
      this.prodId = lottoObj['id'];
      this.sys = lottoObj['system'];
      this.product = lottoObj['product'];
    });
  }

  get lottoIconUrl() {
    let lottoIcon: string;
    if (this.sys === 'wt') {
    } else {
    }
    return lottoIcon;
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  moveToPickerd(): void {
    this._winRef.getNativeWindow().document.getElementById('picker').scrollIntoView();
  }
}
